/**
 * <dogscan-dogvote> — interactive 5-dog result demo.
 * Tap dog noses; readout reflects count vs threshold (0 / below / at-or-above).
 * INSTALL: upload to the theme's assets/.
 */
if (!customElements.get("dogscan-dogvote")) {
  const REDUCE = matchMedia("(prefers-reduced-motion: reduce)").matches;

  class DogscanDogvote extends HTMLElement {
    connectedCallback() {
      this.noses = Array.from(this.querySelectorAll(".dogscan-dogvote__nose"));
      this.readoutEl = this.querySelector("[data-readout]");
      this.countEl = this.querySelector("[data-count]");
      this.titleEl = this.querySelector("[data-title]");
      this.descEl = this.querySelector("[data-desc]");
      if (!this.noses.length || !this.readoutEl) return;

      this.threshold = parseInt(this.dataset.threshold, 10) || 3;
      this.total = this.noses.length;

      this.onClick = this.onClick.bind(this);
      this.noses.forEach((nose) =>
        nose.addEventListener("click", this.onClick)
      );
      this.update();

      if (this.dataset.autodemo === "true" && !REDUCE) this.runDemo();
    }

    disconnectedCallback() {
      this.noses.forEach((nose) =>
        nose.removeEventListener("click", this.onClick)
      );
    }

    onClick(event) {
      this.toggle(event.currentTarget);
    }

    toggle(nose, force) {
      const flagged =
        force === undefined ? !nose.classList.contains("is-flagged") : force;
      nose.classList.toggle("is-flagged", flagged);
      nose.setAttribute("aria-pressed", flagged ? "true" : "false");
      const vote = nose.querySelector(".dogscan-dogvote__vote");
      if (vote)
        vote.textContent = flagged
          ? this.dataset.voteActive || ""
          : this.dataset.voteIdle || "";
      this.update();
    }

    update() {
      const n = this.noses.filter((x) =>
        x.classList.contains("is-flagged")
      ).length;
      if (this.countEl) this.countEl.textContent = n;
      this.readoutEl.classList.remove(
        "dogscan-dogvote__readout--clear",
        "dogscan-dogvote__readout--amb",
        "dogscan-dogvote__readout--flag"
      );
      let key, t, d;
      if (n === 0) {
        key = "clear";
        t = this.dataset.clearTitle;
        d = this.dataset.clearText;
      } else if (n < this.threshold) {
        key = "amb";
        t = this.dataset.ambTitle;
        d = this.dataset.ambText;
      } else {
        key = "flag";
        t = this.dataset.flagTitle;
        d = this.dataset.flagText;
      }
      this.readoutEl.classList.add("dogscan-dogvote__readout--" + key);
      if (this.titleEl) this.titleEl.textContent = this.fill(t, n);
      if (this.descEl) this.descEl.textContent = this.fill(d, n);
    }

    fill(str, n) {
      return (str || "").replace(/\[n\]/g, n).replace(/\[total\]/g, this.total);
    }

    runDemo() {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            const picks = [0, 2, 3].filter((i) => i < this.total);
            picks.forEach((idx, k) => {
              setTimeout(
                () => this.toggle(this.noses[idx], true),
                500 + k * 350
              );
            });
            io.unobserve(e.target);
          });
        },
        { threshold: 0.5 }
      );
      io.observe(this);
    }
  }
  customElements.define("dogscan-dogvote", DogscanDogvote);
}
